import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useRemoveResourceFromPlanzone } from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { id, Identifiable, Resource, ResourceTypes } from "@planzone/dto";
import { ResourceRemovalForm } from "./resourceRemovalForm";
import { InfoUser } from "./infoUser";
import { Props } from "./types";
import styles from "./styles.scss";

function PlanzoneResourceRemoval({ cancel, resource }: Props) {
  const [checked, setChecked] = useState(false);
  const { t } = useTranslation();
  const { removeResourceFromPlanzone, isRequestPending } =
    useRemoveResourceFromPlanzone(resource);
  const [selectedResource, setSelectedResource] =
    React.useState<Identifiable<Resource> | null>(null);

  return (
    <Modal
      className={styles.planzoneResourceRemoval}
      headerClassName={styles.header}
      header={t("removeResourceFromPlanZone.title")}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>
            {t("removeResourceFromPlanZone.description")}
          </p>
          <InfoUser resource={resource} />
          {/*{resource.type !== ResourceTypes.MATERIAL && (*/}
          {/*  <ResourceRemovalForm*/}
          {/*    checked={checked}*/}
          {/*    setChecked={setChecked}*/}
          {/*    resource={resource}*/}
          {/*    formData={selectedResource}*/}
          {/*    edit={setSelectedResource}*/}
          {/*  />*/}
          {/*)}*/}
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeResourceFromPlanZone.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() =>
              removeResourceFromPlanzone({
                resource,
                hasRequestedAllocationTransfer: checked,
                destinationResource: selectedResource
                  ? selectedResource
                  : { ...resource, uuid: id },
              })
            }
          >
            {t("removeResourceFromPlanZone.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { PlanzoneResourceRemoval };
